module.exports = __webpack_public_path__ + "text.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/text.png
// module id = 393
// module chunks = 0